import applyConverters from 'axios-case-converter';
import axios from "axios";
import I18n from "../base/i18n.js";
import GwtTokenStorage from "../utils/gwt_token_storage.js";

const CancelToken = axios.CancelToken;
/**
 * Class for execute server methods like fetching data, updating objects etc.
 * All inheritors must has method `execute()` with specific for request params params
 * @name BaseUseCase
 * @class
 * @abstract
*/
export default class BaseUseCase {
  
  constructor() {
    this.httpClient = applyConverters(axios.create({
    }));
    this.httpClient.interceptors.response.use(
      (response) => {
        this.cancel = undefined;
        const { data, headers } = response;
        if(!data) {
          return Promise.reject(this.unrecognizedServerError());
        }
        if(!data.success) {
          return Promise.reject(data);
        }
        return {
          data: data.data,
          headers: headers
        };
      },
      (error) => {
        this.cancel = undefined;
        const { response } = error;
        if(!response) {
          return Promise.reject(this.unrecognizedServerError());
        }

        const { data } = response;
        if(!data) {
          return Promise.reject(this.unrecognizedServerError());
        }

        return Promise.reject(data);
      }
    );
  }

  /**
   * Object describe unrecognized server error
   * @function 
   * @returns {Object} Server error description
   */

  unrecognizedServerError() {
    return {
      success: false,
      message: I18n.t("errors.exception"),
      errorData: null,
      errorCode: null,
      data: null
    }
  }

  /**
   * Wrap params into passed wrapper and clears negative ids from params
   *
   * For example, object `{id: 1, name: "Name"}` after call that function with wrapped == "item" will be transformed into object `{item: {id: 1, name: "name"}}`
   * @param {Object} params whose must be wrapped
   * @param {String} [wrapper] key for wrapping
   * @returns {Object} wrapped params
   */

  wrapParams(params, wrapper = undefined) {
    this.clearNegativeIds(params);
    if(!wrapper) {
      return {...params}
    }
    return {
      [wrapper]: {...params}
    };
  }

  /**
   * Remove all props named "id" with negative value
   * @param {Object} item Item for clearing
   * @returns {Object} Item without negative ids
   */

  clearNegativeIds(item) {
    Object.keys(item).forEach((key) => {
      if(item[key]) {
        if(item[key] < 0 && key === "id") {
          delete item[key];
        }
        else if(typeof item[key] === 'object' && !Array.isArray(item[key])) {
          this.clearNegativeIds(item[key]);
        }
      }
    });
  }

  /**
   * Configuration for request (headers and cancel token)
   * @returns {Object} request configuration
   */

  requestConfig() {
    let headers = {
      'Content-Type': "application/json",
    };
    if(GwtTokenStorage.get()) {
      headers["Authorization"] = GwtTokenStorage.get();
      headers["X_JWT"] = GwtTokenStorage.get();
    }
    return {
      headers: headers,
      cancelToken: new CancelToken((cancel) => {
        this.cancel = cancel;
      })
    }
  }
}